import { createParser } from 'nuqs';

import { MARKETPLACE_CHANNELS } from '~/constants';
import { MarketplaceChannel } from '~/types/marketplace';

export const isMarketplaceChannel = (channel: string): channel is MarketplaceChannel =>
  typeof channel === 'string' && MARKETPLACE_CHANNELS.includes(channel as MarketplaceChannel);

export const parseChannel = (channel: string | null) => (channel && isMarketplaceChannel(channel) ? channel : null);

export const parseAsMarketplaceChannel = createParser({
  parse: parseChannel,
  serialize: (value: MarketplaceChannel | null) => value?.toString() ?? '',
});
